import React from 'react'
import SpinnerSvg from './SpinnerSvg'
import cl from "./Spinner.module.css";

const Spinner = () => {
  return (
    <div className={cl.wrapper}>
        <SpinnerSvg color={"#06F"} className={cl.spinner}/>
    </div>
  )
}

export default Spinner